<template>
    <div class="layout__height-1300px layout__overflow-hidden">
        <!--<iframe src="http://localhost:8080/fulfilment" width="100%" height="100%;" class="layout__height-3040px">-->
        <iframe :src="iframe_src" width="100%" height="100%;" class="layout__height-1240px" scrolling="no" webkitAllowFullScreen mozallowfullscreen msallowfullscreen allowFullScreen>

        </iframe>
    </div>
</template>

<script>

    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import Stepguide from "../../../components/tools/quote/StepGuide";

    export default {
        name: "generateaquote",
        props: {},
        components: {
            Stepguide
        },
        mixins: [axios, dataFormatter, backing],
        computed: {
            iframe_src: {
                get: function() {
                    //var dm_path = `${process.env.VUE_APP_INSTANT_MARKETING_IFRAME}?auth_token=${window.sessionStorage.getItem('_token')}&showProfile=false&version=${process.env.VUE_APP_DIRECTMAILR_VERSIONNUMBER}`;
                    var dm_path = `${process.env.VUE_APP_INSTANT_MARKETING_IFRAME}?auth_token=${window.sessionStorage.getItem('_token')}&version=${process.env.VUE_APP_DIRECTMAILR_VERSIONNUMBER}`;

                    var showProfile = window.sessionStorage.getItem('_showProfile');
                    console.log('showProfile=' + showProfile);

                    if (showProfile !== undefined && showProfile !== null) {
                        dm_path += '&showProfile=true';
                    }

                    window.sessionStorage.removeItem('_showProfile');

                    var showTemplates = window.sessionStorage.getItem('_showTemplates');
                    console.log('showTemplates=' + showTemplates);

                    if (showTemplates !== undefined && showTemplates !== null) {
                        dm_path += '&showTemplates=true';
                    }

                    window.sessionStorage.removeItem('_showTemplates');

                    if (this.$route.query.page !== undefined) {
                        dm_path += '&gotoPage=' + this.$route.query.page + '&orderId=' + this.$route.query.order_id;
                    }

                    return dm_path
                }
            }
        },
        data() {
            return {
            }
        },
        beforeUpdate() {
        },
        created() {
          if (!window.sessionStorage.getItem('_customer')) {
            this.$router.push({
              name: '/directmailr',
              params: {
                showPopup: true,
              }
            });
          }
        },
        mounted() {
        },
        methods: {
        },
    };
</script>